<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<blockquote>
<blockquote>
<blockquote>
<p class="parac"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="para"> </p>
<p class="center-parac"><span class="smallcaps">A THOMAS DUNNE BOOK FOR MINOTAUR BOOKS.</span><br/>An imprint of St. Martin’s Publishing Group.</p>
<p class="para"> </p>
<p class="parac"><span class="smallcaps">CITY OF DRAGONS</span>. Copyright © 2010 by Kelli Stanley. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="center-parac"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a><br/><a href="http://www.minotaurbooks.com" target="_blank">www.minotaurbooks.com</a></p>
<p class="para"> </p>
<p class="center-parac">Design by Kathryn Parise</p>
<p class="para"> </p>
<p class="parac"><span class="smallcaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="para"> </p>
<p class="parac">Stanley, Kelli.</p>
<p class="indent-parac">City of dragons / Kelli Stanley. — 1st ed.</p>
<p class="indent-parac">      p. cm.</p>
<p class="indent-parac">“A Thomas Dunne book.”</p>
<p class="indent-parac">ISBN 978-0-312-60360-1</p>
<p class="parac">  1. Women private investigators—California—Fiction.</p>
<p class="parac">2. San Francisco (Calif.)—History—20th century—<br/>Fiction. 3. Chinatown (San Francisco, Calif.)—Fiction.</p>
<p class="parac">I. Title.</p>
<p class="indent-parac">PS3619.T3657C58    2010</p>
<p class="indent-parac">813'.6—dc22</p>
<p class="right-para">2009039817</p>
<p class="para"> </p>
<p class="center-parac">First Edition: February 2010</p>
<p class="para"> </p>
<p class="center-parac">10  9  8  7  6  5  4  3  2  1</p>
</blockquote>
</blockquote>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5549e578